import Link from "../Link/Link";
import { useRadarList } from "../../hooks/UseRadarList";
import "./page-list.scss";

export default function PageList() {
  const { data } = useRadarList();

  return (
    <div className="page-list">
      <div className="hero-headline highlight highlight--peach">Select a Radar </div>
      {data?.pages?.items && data?.pages?.items?.length > 0 && (
        <ul className="page-list__list">
          {data?.pages?.items.map(
            (item, index) =>
              item?.slug && (
                <li key={`${item?.slug}`}>
                  <Link className="page-list__link" pageName={item.slug}>
                    {item?.title}
                  </Link>
                </li>
              )
          )}
        </ul>
      )}
    </div>
  );
}
